import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound, Mail, Wallet, LogOut } from "lucide-react";
import client, { setToken } from "@/lib/api";

const ICON = { password: Mail, google: KeyRound, wallet: Wallet };
const LABEL = { password: "Email & password", google: "Google", wallet: "Wallet" };
const EVENT = {
  login: "Signed in", account_created: "Account created", wallet_linked: "Wallet linked", wallet_unlinked: "Wallet removed",
  wallet_link_conflict: "Wallet link blocked (already linked elsewhere)", step_up: "Identity re-confirmed",
  nickname_changed: "Nickname changed", sessions_revoked: "Signed out of all devices",
  wallet_signin_enabled: "Wallet sign-in turned on", wallet_signin_disabled: "Wallet sign-in turned off",
  account_suspended: "Account suspended", account_active: "Account reactivated",
};

export function SecuritySection() {
  const [d, setD] = useState(null);
  useEffect(() => { client.get("/account/security").then((r) => setD(r.data)); }, []);

  const logoutAll = async () => {
    const r = await client.post("/account/logout-all");
    setToken(r.data.token);
    toast.success("Signed out of all other devices");
    client.get("/account/security").then((x) => setD(x.data));
  };
  if (!d) return null;

  return (
    <div className="grid gap-10 lg:grid-cols-2">
      <div>
        <h2 className="font-display text-lg font-bold mb-4">Sign-in methods</h2>
        <div className="space-y-2" data-testid="security-methods">
          {d.methods.map((m, i) => {
            const Icon = ICON[m.type];
            return (
              <div key={i} data-testid={`security-method-${m.type}`} className="flex items-center gap-3 rounded-xl border border-white/10 px-4 py-3">
                <Icon className="w-4 h-4 text-[#ccff00]" />
                <div className="min-w-0"><p className="text-sm font-medium">{LABEL[m.type]}</p><p className="text-xs text-zinc-500 truncate">{m.label}</p></div>
                {!m.usable && <span className="ml-auto text-[10px] uppercase tracking-widest text-amber-300">Unverified</span>}
              </div>
            );
          })}
        </div>
        <button data-testid="logout-all-btn" onClick={logoutAll} className="mt-6 flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-sm hover:border-red-400/50 hover:text-red-300">
          <LogOut className="w-4 h-4" /> Sign out of all other devices
        </button>
      </div>
      <div>
        <h2 className="font-display text-lg font-bold mb-4">Recent security activity</h2>
        <ul className="space-y-1" data-testid="security-events">
          {d.events.map((e) => (
            <li key={e.id} className="flex justify-between gap-4 text-sm border-b border-white/5 py-2">
              <span>{EVENT[e.event] || e.event}{e.meta?.method ? ` · ${LABEL[e.meta.method] || e.meta.method}` : ""}{e.meta?.address ? ` · ${e.meta.address}` : ""}</span>
              <span className="text-xs text-zinc-500 shrink-0">{new Date(e.created_at).toLocaleString()}</span>
            </li>
          ))}
          {d.events.length === 0 && <li className="text-sm text-zinc-500">No activity yet.</li>}
        </ul>
      </div>
    </div>
  );
}
